import Image from '@components/Image'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import { ElementHTML } from '@helpers/helper.rendering'
const AboutUs20 = (props: RealEstateDataPageComponentData) => {
  const {
    image_gatsby,
    paragraphElement,
    opacityValue,
    paragraphs,
    title,
    titleElement,
    align,
    height,
    titleColor,
    titleHexa,
  } = props

  const [isMounted, setIsMounted] = useState(false)

  const normalizedOpacity = Number(opacityValue) / 100

  useEffect(() => {
    setIsMounted(true)
  }, [])

  return (
    isMounted && (
      <section
        className={`about-us-16 a about-us-20 w-100`}
        style={{
          height: screen.width < 992 ? height?.mobile ?? 'auto' : height?.desktop ?? 'auto',
        }}
      >
        <div
          className="opacity"
          style={{
            opacity:
              opacityValue && opacityValue !== '0'
                ? Number(opacityValue) !== 100
                  ? normalizedOpacity
                  : 1
                : 0.6,
          }}
        ></div>
        <Image
          className=" h-100 background-image-absolute no-border"
          objectFit="cover"
          alt="about-us-img"
          image={image_gatsby!!}
        />
        <Container
          fluid
          className={`d-flex h-100 align-items-center `}
        >
          <Row
            className={`d-flex align-items-center justify-content-${
              align === 'left' ? 'start' : align === 'right' ? 'end' : align
            }`}
          >
            <Col
              xs={12}
              lg={6}
              className='px-lg-5 mx-lg-5'
            >
              {title && (
                <ElementHTML
                  children={title}
                  elementType={titleElement ?? 'h1'}
                  className={`${align === 'center' ? 'text-center' : ''} ${titleColor}`}
                  style={{ color: titleColor === 'text-picker' ? titleHexa : '' }}
                />
              )}
              {paragraphs?.map((paragraph, index) => (
                <ElementHTML
                  key={index}
                  children={paragraph}
                  elementType={paragraphElement || 'h5'}
                  className={`${align === 'center' ? 'text-center' : ''} sub-section mb-0`}
                  style={{ lineHeight: '23px' }}
                />
              ))}
            </Col>
          </Row>
        </Container>
      </section>
    )
  )
}

export default AboutUs20
